// Projeta um imóvel de /imoveis para o formato sanitizado publicado em /imoveisPublicos.
// Mantém apenas os campos exibidos no site público — nunca inclua ownerInfo ou control aqui.
export function buildPublicImovel(id, data = {}) {
  const imovelInfo = data.imovelInfo || {};
  const caracteristicas = data.caracteristicas || {};
  const informacoesComerciais = data.informacoesComerciais || {};
  const informacoesAdicionais = data.informacoesAdicionais || {};

  return {
    id,
    imovelInfo: {
      codigo: imovelInfo.codigo || "",
      corretor: imovelInfo.corretor || "",
      construtora: imovelInfo.construtora || "",
      titulo: imovelInfo.titulo || "",
      modalidade: imovelInfo.modalidade || "",
      cidade: imovelInfo.cidade || "",
      bairro: imovelInfo.bairro || "",
      endereco: imovelInfo.endereco || "",
      referencia: imovelInfo.referencia || "",
      complemento: imovelInfo.complemento || "",
      cep: imovelInfo.cep || "",
      tipo: imovelInfo.tipo || "",
      descricao: imovelInfo.descricao || "",
      status: imovelInfo.status === true,
    },
    caracteristicas: { ...caracteristicas },
    informacoesComerciais: {
      tipoVenda: informacoesComerciais.tipoVenda || "",
      valor: informacoesComerciais.valor || "",
      condominio: informacoesComerciais.condominio || "",
    },
    informacoesAdicionais: {
      exclusivo: informacoesAdicionais.exclusivo || "",
      linkLocalizacao: informacoesAdicionais.linkLocalizacao || "",
    },
    selectedItems: Array.isArray(data.selectedItems) ? data.selectedItems : [],
    imagesLinks: data.imagesLinks || {},
    bookTecnicoURL: data.bookTecnicoURL || "",
    watermarked: data?.control?.watermarked === true,
  };
}
